import { ApiRoutes } from '../helpers/routes'
import { SimplePostDTO } from '../models/post'
import fetchApi from './fetchApi'

const baseUrl = `${process.env.REACT_APP_API_URL}/api/posts`

class PostService {
    createPost = async (post: SimplePostDTO) => {
        return fetchApi(`${baseUrl}`, {
            method: 'POST',
            body: JSON.stringify(post),
        })
    }

    getPublishedPosts = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.published}`, {
            method: 'GET',
        })
    }

    getPendingPosts = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.pending}`, {
            method: 'GET',
        })
    }

    getMyPendingPosts = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.myPending}`, {
            method: 'GET',
        })
    }

    getMyPosts = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.me}`, {
            method: 'GET',
        })
    }

    getRejectedPosts = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.rejected}`, {
            method: 'GET',
        })
    }

    getPublishedPostsByUser = async (userId: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.published}/${userId}`, {
            method: 'GET',
        })
    }

    editPost = async (postId: string, post: SimplePostDTO) => {
        return fetchApi(`${baseUrl}/${postId}`, {
            method: 'PUT',
            body: JSON.stringify(post),
        })
    }

    deletePost = async (postId: string) => {
        return fetchApi(`${baseUrl}/${postId}`, {
            method: 'DELETE',
        })
    }

    approvePost = async (postId: string) => {
        return fetchApi(`${baseUrl}/${postId}${ApiRoutes.posts.approve}`, {
            method: 'PATCH',
        })
    }

    rejectPost = async (postId: string, object: { rejectionReason: string }) => {
        return fetchApi(`${baseUrl}/${postId}${ApiRoutes.posts.reject}`, {
            method: 'PATCH',
            body: JSON.stringify(object),
        })
    }

    likePost = async (postId: string) => {
        return fetchApi(`${baseUrl}/${postId}${ApiRoutes.posts.likes}`, {
            method: 'POST',
        })
    }

    dislikePost = async (postId: string) => {
        return fetchApi(`${baseUrl}/${postId}${ApiRoutes.posts.likes}`, {
            method: 'DELETE',
        })
    }

    commentPost = async (postId: string, comment: string) => {
        return fetchApi(`${baseUrl}/${postId}${ApiRoutes.posts.comments}`, {
            method: 'POST',
            body: JSON.stringify({ content: comment }),
        })
    }

    editCommentPost = async (postId: string, commentId: string, comment: string) => {
        return fetchApi(`${baseUrl}/${postId}${ApiRoutes.posts.comments}/${commentId}`, {
            method: 'PATCH',
            body: JSON.stringify({ content: comment }),
        })
    }

    deleteCommentPost = async (postId: string, commentId: string) => {
        return fetchApi(`${baseUrl}/${postId}${ApiRoutes.posts.comments}/${commentId}`, {
            method: 'DELETE',
        })
    }

    getNewsAndEvents = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.newsAndEvents}`, {
            method: 'GET',
        })
    }

    getPostById = async (eventId: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.events}/${eventId}`, {
            method: 'GET',
        })
    }

    createEvent = async (post: SimplePostDTO) => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.events}`, {
            method: 'POST',
            body: JSON.stringify(post),
        })
    }

    editEvent = async (eventId: string, post: SimplePostDTO) => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.events}/${eventId}`, {
            method: 'PUT',
            body: JSON.stringify({ ...post, dayOfEventNew: post.dayOfEvent }),
        })
    }

    joinEvent = async (eventId: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.events}/${eventId}/addAttendees`, {
            method: 'PUT',
        })
    }

    leaveEvent = async (eventId: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.events}/${eventId}/removeAttendees`, {
            method: 'PUT',
        })
    }

    createBenefit = async (post: SimplePostDTO) => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.benefits}`, {
            method: 'POST',
            body: JSON.stringify(post),
        })
    }

    getBenefits = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.benefits}`, {
            method: 'GET',
        })
    }

    getBenefitById = async (id: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.posts.benefits}/${id}`, {
            method: 'GET',
        })
    }
}

export default PostService
